// action - account reducer
export const LOGIN = "@auth/LOGIN";
export const LOGOUT = "@auth/LOGOUT";
export const REGISTER_CLIENT_SUCCESS = "@auth/REGISTER_CLIENT_SUCCESS";
export const REGISTER_CLIENT_FAIL = "@auth/REGISTER_CLIENT_FAIL";
export const VERIFYEMAIL = "@auth/VERIFYEMAIL";
export const HASERROR = "@auth/HASERROR";
export const FORGOTPASSWORD = "@auth/FORGOTPASSWORD";
export const USERSTATUS = "@auth/USERSTATUS";
